import moment from "moment";

export const toLocalDateString = (date: Date) => {
  const year = moment(date).get("year");
  const month = String(moment(date).get("month") + 1).padStart(2, "0");
  const day = String(moment(date).get("date")).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const toLocalTimeString = (date: Date) => {
  const year = moment(date).get("year");
  const month = String(moment(date).get("month") + 1).padStart(2, "0");
  const day = String(moment(date).get("date")).padStart(2, "0");
  const hours = String(moment(date).get("hours")).padStart(2, "0");
  const minutes = String(moment(date).get("minutes")).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
